import { render, staticRenderFns } from "./ValidarRespuestaModal.vue?vue&type=template&id=4130a3d1&scoped=true&"
import script from "./ValidarRespuestaModal.vue?vue&type=script&lang=ts&"
export * from "./ValidarRespuestaModal.vue?vue&type=script&lang=ts&"
import style0 from "./ValidarRespuestaModal.vue?vue&type=style&index=0&id=4130a3d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130a3d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4130a3d1', component.options)
    } else {
      api.reload('4130a3d1', component.options)
    }
    module.hot.accept("./ValidarRespuestaModal.vue?vue&type=template&id=4130a3d1&scoped=true&", function () {
      api.rerender('4130a3d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/ValidarRespuestaModal.vue"
export default component.exports